<div class="container-fluid vh-100">
  <div class="row h-100">
    <div class="col-lg-6 col-md-6 d-none d-lg-flex login-left align-items-end">
      <div class="overlay"></div>
      <div class="text-white p-5" style="z-index: 2;">
        <h1>{{"GENERAL.SIGN_IN_TO_MANAGE_YOUR_SUPPLIES_EASILY"|translate}}</h1>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="login-right">
        <div class="w-75 my-4 d-flex justify-content-end">
          <app-switch-language></app-switch-language>
        </div>
        <div class="login-header">
          <img class="w-100-px" src="../../../../../../assets/images/logo.png" alt="">
          <h4>{{"GENERAL.NICE_TO_SEE_YOU_AGAIN" | translate}}</h4>
        </div>
        <div class="login-form">
          <app-form *ngIf="form.length" [validationEmit]="validationEmit" [formConfig]="form" [hasButton]="false"
            (onChange)="valueChanged($event)" [validationErrors]="validationErrors" (onSubmit)="submitForm($event)"
            [changeSensitive]="true"></app-form><!-- (keydown)="handleKeydown($event)" -->
          <div class="d-flex justify-content-end">
            <a class="forget-password" [routerLink]="['/auth/forget-password']">
              {{ "GENERAL.FORGET_PASSWORD" | translate }}
            </a>
          </div>

          <div class="loginBtn mt-3">
            <button class="btn btn-primary w-100"
              (click)="this.validationEmit = !this.validationEmit">{{"GENERAL.LOGIN"|translate}}</button>
          </div>
          <!-- <div class="sign-up-section text-center mt-4 pt-4">
            <p class="sec-color">{{"Don't have an account?"|translate}} <a routerLink="/auth/register"
                class="main-color">{{"Sign up now"|translate}}</a></p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>